// Architecture Guide:  https://medium.freecodecamp.org/react-redux-architecture-part-1-separation-of-concerns-812da3b08b46
// Actions comprises functionalities which define your application.
// It includes:
// Business Logic
// Handling routes
// API Calls
// Authentications
// Validations
// Controlling component’s state

export const GET_DATA = "GET_DATA"; //GET fetch call
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS"; //on successful GET fetch call
export const POST_DATA = "POST_DATA"; //POST fetch call
export const POST_DATA_SUCCESS = "POST_DATA_SUCCESS"; //on successful POST fetch call
export const SET_PROFILE_INDEX = "SET_PROFILE_INDEX";
export const RESULT = "RESULT"; //ant design result object
export const GET_JOB_SUCCESS = "GET_JOB_SUCCESS"; //get scrapestats
export const SET_USER_THUMBNAILS = "SET_USER_THUMBNAILS";
